import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ToursForm from "../../../Components/tours/ToursForm";
import { Tours } from "../../../store/Tours/type";
import { createTours } from "../../../store/Tours";
import { toast } from "react-toastify";
import { RootState } from "../../../store";
import { fetchEventDrafts } from "../../../store/Drafts";

const CreateToursForm: FunctionComponent = () => {
  const [formData, setFormData] = useState<any>({});  
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const data = await dispatch(fetchEventDrafts('tour'));
      if (data?.length > 0) {
        const draft = (data as any)[0];
        console.log('------data fetched tour', draft);
        setFormData(draft);
      } else {
        setFormData({ id: 'non-draft' })
      }
    };
    if(pathname.includes('/tours/add')) {
      fetchData();
    } else {
      setFormData({ id: 'non-draft' })
    }
  }, [])

  const onSubmit = async (tour: Tours, isDraft: boolean = false) => {
    try {
      delete (tour as any).available
      await dispatch(createTours(tour, isDraft));
      toast.success("Successfully requested for approval");
      history.push("/profile/tours");
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };
  const genralLan = useSelector(
    (rootState: RootState) => rootState?.language?.language?.content!
  );
  return formData?.id ? (
    <div className="col-lg-9 col-12">
      <div className="section-wrap paddresup">
        <section className="form-wrap">
          <h4 className="com-font fw700 text-red text-capitalize">
            {genralLan?.general?.add + ' ' + genralLan?.general?.new + ' ' + genralLan?.general?.tour}
          </h4>
          {/* <ToursForm onSubmit={onSubmit} /> */}
          <ToursForm onSubmit={onSubmit} initialData={formData} isDraft={formData?.id === 'non-draft' ? false : true} hasReservations={false}/>
        </section>
      </div>
    </div>
  ): <></>;
};

export default CreateToursForm;
